import React, { useEffect, useState } from "react";
import Header from "../../partials/VAHeader";
import Sidebar from "../../partials/SidebarExternal";
import styles from "./style.module.css";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "sweetalert2/dist/sweetalert2.min.css";
import HashLoader from "react-spinners/ClipLoader";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
const List = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("apiToken");

  const [lockerhistory, setLockerHistory] = useState([]);
  const [statsData, setStats] = useState({});
  let { slug } = useParams();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [credentials, setCredentials] = useState({ status: "all", name: "" });
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // Function to toggle the active state
  const toggleActive = () => {
    setIsActive(!isActive);
  };

  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";

  function toggleFilterSection() {
    setIsFilterVisible(!isFilterVisible);
  }
  const [data, setChartData] = useState([
    { month: "January", collected: 0, distributed: 0 },
    { month: "February", collected: 0, distributed: 0 },
    { month: "March", collected: 0, distributed: 0 },
    { month: "April", collected: 0, distributed: 0 },
    { month: "May", collected: 0, distributed: 0 },
  ]);
  const stats = {
    bagsCheckedIn: 120,
    bagsDistributed: 85,
    avgStayLength: "3 days",
    oldestProperty: "2023-01-15",
  };
  useEffect(() => {
    fetchData();
    fetchLockerHistory();
  }, []);

  const fetchData = async (fetchCredentials) => {
    try {
      setIsLoading(true);
      const response = await fetch(`${apiUrl}/api/history/property`, {
        mode: "cors",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setIsLoading(false);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();

      if (json?.status) {
        setChartData(json?.monthlyData);

        setStats(json?.avgStats[0]);
      } else {
        setChartData([]);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
      console.error(error);
    }
  };
  const fetchLockerHistory = async (fetchCredentials) => {
    try {
      setIsLoading(true);
      const response = await fetch(`${apiUrl}/api/history/?page=1&limit=10`, {
        mode: "cors",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setIsLoading(false);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();

      if (json?.locker_history?.length > 0) {
        setLockerHistory(json?.locker_history);
      } else {
        setLockerHistory([]);
      }
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    }
  };

  const formattedDate = (date) => {
    if (!date) {
      // If date is empty or null, use the current date
      date = new Date();
    }

    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  return (
    <div className={styles.heading}>
      <div className="body-wrap">
        <section className={styles.sidebar_wrap}>
          <div className="container-fluid px-0">
            <div className="row">
              <div className={`col col-sidebar  ${divClassName} `}>
                <Sidebar />
              </div>
              <div className="col col-dashboard mt-5">
                <div className="general-dashboard mt-3">
                  <div className="container-fluid">
                    <div className="dashboard-top-row">
                      <div className="row">
                        <div className="col-lg-6 my-auto">
                          <div className="user-wrap">
                            <h3>Dashboard</h3>
                            <p>List of all the lockers in the system</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* row */}
                  </div>
                  <div className="p-4 border rounded-lg shadow-md bg-white mt-5">
                    {/* Stats Section */}
                    <div className="d-flex flex-column align-items-center mb-4">
                      <div
                        className="d-flex align-items-center justify-content-center border-2 border-gray-300 rounded-circle"
                        style={{ width: "50px", height: "50px" }}
                      >
                        <img
                          src="/assets/statistic.png"
                          className="text-gray-600"
                          alt="statistic"
                          style={{ width: "24px", height: "24px" }}
                        />
                      </div>
                      <h3 className="text-dark text-lg mt-2">Key Statistics</h3>
                    </div>

                    {/* Stats Grid */}
                    <div className="d-flex flex-wrap justify-content-center gap-4">
                      {/* Bags Checked In */}
                      <div className="bg-light p-4 rounded-lg px-4 d-flex flex-column justify-content-center align-items-center ">
                        <img
                          src="/assets/collecting.png"
                          className="h-10 w-10 mb-2"
                          alt="checked-in"
                          style={{ width: "50px", height: "50px" }} // Ensures equal image size
                        />
                        <p className="h5 font-weight-bold">
                          {statsData?.totalCollected || 0}
                        </p>
                        <p className="text-muted text-sm">Property Collected</p>
                      </div>

                      {/* Bags Distributed */}
                      <div className="bg-light p-4 rounded-lg d-flex flex-column justify-content-center align-items-center">
                        <img
                          src="/assets/distrubting.png"
                          className="h-10 w-10 mb-2"
                          alt="distributing"
                          style={{ width: "50px", height: "50px" }} // Ensures equal image size
                        />
                        <p className="h5 font-weight-bold">
                          {statsData?.totalDistributed || 0}
                        </p>
                        <p className="text-muted text-sm">
                          Property Distributed
                        </p>
                      </div>

                      {/* Avg Stay Length */}
                      <div className="bg-light p-4 rounded-lg d-flex flex-column justify-content-center align-items-center">
                        <img
                          src="/assets/avg-length.png"
                          className="h-10 w-10 mb-2"
                          alt="avg-stay-length"
                          style={{ width: "50px", height: "50px" }} // Ensures equal image size
                        />
                        <p className="h5 font-weight-bold">
                          {statsData?.avgStayLength || 0}
                        </p>
                        <p className="text-muted text-sm">Avg. Stay Length</p>
                      </div>

                      {/* Oldest Property */}
                      <div className="bg-light p-4 rounded-lg d-flex flex-column justify-content-center align-items-center">
                        <img
                          src="/assets/old-propert.png"
                          className="h-10 w-10 mb-2"
                          alt="oldest-property"
                          style={{ width: "50px", height: "50px" }} // Ensures equal image size
                        />
                        <p className="h5 font-weight-bold">
                          {formattedDate(statsData?.oldestProperty)}
                        </p>
                        <p className="text-muted text-sm">Oldest Property</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 border rounded-lg shadow-md bg-white mt-3">
                    <h2 className="text-lg font-bold mb-4">Property </h2>
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart
                        data={data}
                        margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                      >
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar
                          dataKey="collected"
                          fill="#4F46E5"
                          name="Collected"
                          barSize={40}
                        />
                        <Bar
                          dataKey="distributed"
                          fill="#EF4444"
                          name="Distributed"
                          barSize={40}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>

                  <div className="p-4 border rounded-lg shadow-md bg-white mt-5">
                    <h2 className="text-lg font-bold mb-4">Locker History </h2>

                    <div className="table-wrap">
                      <div className="row">
                        <div className="col-12">
                          <div className={styles.card_box}>
                            <div className={styles.tables_wrap}>
                              <div className="table-responsive">
                                <table className="table align-middle">
                                  <thead>
                                    <tr>
                                      <th>User</th>
                                      <th>Locker no</th>
                                      <th>Site</th>
                                      <th>Type</th>
                                      <th>Reason</th>
                                      <th>Date</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {isLoading && (
                                      <tr>
                                        <td
                                          colSpan={6}
                                          className="text-center"
                                          style={{
                                            background: "transparent",
                                          }}
                                        >
                                          <HashLoader
                                            color={`#0b0d41`}
                                            loading={isLoading}
                                            size={40}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                          />
                                        </td>
                                      </tr>
                                    )}
                                    {lockerhistory.length > 0 ? (
                                      lockerhistory.map((item, i) => (
                                        <tr key={i}>
                                          <td>
                                            <div className="usr_det_tb">
                                              <span>{item.user_id?.name}</span>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="usr_det_tb">
                                              <span>{item.locker_number}</span>
                                            </div>
                                          </td>
                                          <td>{item.site}</td>
                                          <td>{item.type}</td>
                                          <td>{item.reason}</td>
                                          <td>
                                            {formattedDate(item.created_at)}
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan={6} className="text-center">
                                          <p className="text-center text-danger">
                                            No data found.
                                          </p>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default List;
